const navConstants = {
  NAV_EXPAND_SECTION:            'NAV_EXPAND_SECTION',
  NAV_GET_INITIAL_STATE_FAILURE: 'NAV_GET_INITIAL_STATE_FAILURE',
  NAV_GET_INITIAL_STATE_REQUEST: 'NAV_GET_INITIAL_STATE_REQUEST',
  NAV_GET_INITIAL_STATE_SUCCESS: 'NAV_GET_INITIAL_STATE_SUCCESS',
  NAV_SET_BEHAVIOR:              'NAV_SET_BEHAVIOR',
  NAV_TOGGLE_STATE:              'NAV_TOGGLE_STATE',
  STORAGE:                       'NAVIGATION_STORAGE',
};

export default navConstants;